import GridComponent from '../../component/grid/GridComponent.component';
import Card from '../../component/card/Card.component';
import Grid from '@material-ui/core/Grid';
import ButtonLink from '../../component/buttton/ButtonLink.component';
import Router from './Schedule.container';
import { Container } from '../../component/container/Container';
import { BiChevronRight } from 'react-icons/bi';

export default function ScheduleComponent() {

    return (
        <Container margin="0px 0px 40px 0px">
            <GridComponent spacing={2}>
                <Grid item>
                    <ButtonLink title="Bandeiras" link='/manutencao-horarios' icon={<BiChevronRight />} />
                </Grid>
                <Grid item>
                    <ButtonLink title="Regionais" link='/manutencao-horarios/regionais' icon={<BiChevronRight />} />
                </Grid>
                <Grid item>
                    <ButtonLink title="Formatos" link='/manutencao-horarios/formatos' icon={<BiChevronRight />} />
                </Grid>
                 <Grid item>
                    <ButtonLink title="Importar Dados das Lojas" link='/manutencao-horarios/importar' icon={<BiChevronRight />} />
                </Grid>
            </GridComponent>

            <Card color="#fbfbfb" padding={'10px 20px'} margin='20px 0px 0px 0px' >
                <Grid item sm={12}>
                    <Router />
                </Grid>
            </Card>
        </Container>
    );
}
